import { useGetPromoCode } from '@dhl/mdp-api'
import { convertToPromoCode } from '~/modules/promocodes/model'

export const usePromoCode = (id: string | undefined) => {
  const { data: promoCodeDto, isLoading } = useGetPromoCode(id ?? '', { query: { enabled: !!id } })
  const promoCode = promoCodeDto ? convertToPromoCode(promoCodeDto) : undefined
  return { promoCode, isLoading }
}
